import PurchaseOrderCard from "@molecules/ObjectCard/ObjectCards/PurchaseOrderCard/PurchaseOrderCard"

import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

export default function PurchaseOrderCardsView() {
    return (
        <CardsView.List<PurchaseOrder>>
            {(purchaseOrder, displayedAttributes) => (
                <PurchaseOrderCard purchaseOrder={purchaseOrder} displayedAttributes={displayedAttributes} />
            )}
        </CardsView.List>
    )
}
